import React from 'react';
import styles from './styles.module.scss';

const MazTuInfoBeesAccountCard = ({ children }) => {
  return (
    <div className={styles.card}>
      {children}
    </div>
  );
};

export default MazTuInfoBeesAccountCard;
